<div>
    <h3 class="mb-4">Thank you for the information.</h3>
    <v-btn :disabled="!token" @click="changeData">Change data</v-btn>
</div>
